import { render, staticRenderFns } from "./quotationBidConfirm.vue?vue&type=template&id=23074936&scoped=true"
import script from "./quotationBidConfirm.vue?vue&type=script&lang=js"
export * from "./quotationBidConfirm.vue?vue&type=script&lang=js"
import style0 from "./quotationBidConfirm.vue?vue&type=style&index=0&id=23074936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23074936",
  null
  
)

export default component.exports